import React, { useEffect, useRef } from 'react';
import { fadeIn } from '../../utils/gsapAnimations';

function ShippingOptions() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const items = sectionRef.current.querySelectorAll('.option-item');
    items.forEach((item, index) => {
      fadeIn(item, 0.3 + index * 0.2);
    });
  }, []);

  const options = [
    {
      title: 'Standard Shipping',
      cost: '₦5.99',
      timeline: '5-7 business days',
      description: 'Reliable delivery for all domestic orders.',
    },
    {
      title: 'Express Shipping',
      cost: '₦14.99',
      timeline: '2-3 business days',
      description: 'Fast delivery for when you need it sooner.',
    },
    {
      title: 'International Shipping',
      cost: 'Varies',
      timeline: '7-14 business days',
      description: 'Available to select countries. Costs calculated at checkout.',
    },
  ];

  return (
    <div ref={sectionRef} className="py-12 px-4">
      <h2 className="text-2xl font-lora font-semibold text-burgundy mb-6 text-center">Shipping Options</h2>
      <div className="flex flex-col gap-6 max-w-4xl mx-auto">
        {options.map((option, index) => (
          <div
            key={index}
            className="option-item p-4 bg-cream rounded-lg shadow-md text-center"
          >
            <h3 className="text-lg font-poppins font-semibold text-burgundy">{option.title}</h3>
            <p className="text-poppins text-burgundy font-semibold mt-2">{option.cost}</p>
            <p className="text-poppins mt-1">{option.timeline}</p>
            <p className="text-poppins mt-2">{option.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShippingOptions;